import backIcon from "assets/images/back-icon.svg";
import { Link, useHistory } from "react-router-dom";
import {
  getNextOnboardingPage,
  getPreviousOnboardingPage,
} from "../../../routes/onboardingRoutes";
import * as Styles from "./TermsInfoStyles";
import { Input, Checkbox, Select } from "antd";
import countryCodesJson from "./countryCodes.json";
import { FaChevronDown } from "react-icons/fa6";
import { useEffect, useMemo, useState } from "react";
import { getOnboardingStorage, setOnboardingStorage } from "../storage";
import { useDispatch, useSelector } from "react-redux";
import * as CoachActions from "redux/coach/coach.actions";
import * as AuthActions from "redux/auth/auth.actions";
import { IS_LOCAL } from "configs/utils";
import { getPreparedRegistrationData } from "../utils";
import { REGISTER_STEP } from "../storage";
import OnboardingLoader from "../wrapper/OnboardingLoader";
import moment from "moment";
import countryList from "react-select-country-list";

import { updateUserInfo } from "services/payment";

function TermsInfo({ currentPath }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const coach = useSelector((state) => state.coach.coach);

  const [loading, setLoading] = useState(false);
  const [registrationError, setRegistrationError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [fieldData, setFieldData] = useState({
    firstName: "",
    lastName: "",
    email: "",  
    phoneNumber: "",
    street: "",
    houseNumber: "",
    city: "",
    zipcode: "",
    country: { value: "DE", label: "Deutschland" },
    dataCheckbox: false,
    termsCheckbox: false,
    selectedCountryCode: "+49",
  });

  useEffect(() => {
    const coach_website_url = IS_LOCAL
      ? "https://sebastian-fci1.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    if (coach) return;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: () => null,
            })
          );
        },
      })
    );
  }, [dispatch, coach]);

  useEffect(() => {
    setValidationErrors({});
  }, [fieldData]);

  const countryCodes = countryCodesJson.map((country) => ({
    ...country,
    label: `${country.flag} ${country.dial_code}`,
    value: country.dial_code,
  }));

  const countryOptions = useMemo(() => {
    const options = countryList().getData();

    // Common European countries to show first
    const priorityCountries = [
      "DE",
      "AT",
      "CH",
      "NL",
      "BE",
      "LU",
      "FR",
      "IT",
      "ES",
    ];

    // Filter and sort countries to prioritize European ones
    const sortedOptions = options
      .map((country) => ({
        value: country.label,
        label: country.label,
        flag: country.value,
      }))
      .sort((a, b) => {
        const aIndex = priorityCountries.indexOf(a.value);
        const bIndex = priorityCountries.indexOf(b.value);

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return a.label.localeCompare(b.label);
      });

    return sortedOptions;
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldData({
      ...fieldData,
      [name]: value,
    });
  };
  const handleCountryChange = (selectedOption) => {
    setFieldData({
      ...fieldData,
      country: selectedOption,
    });
    setValidationErrors((prev) => ({ ...prev, country: false }));
  };

  const validateFields = (fields = fieldData) => {
    const fieldNames = [
      "firstName",
      "lastName",
      "email",
      "phoneNumber",
      "dataCheckbox",
      "termsCheckbox",
      "street",
      "houseNumber",
      "city",
      "zipcode",
      "country",
    ];
    const errors = {};
    let foundErrors = false;
    errors["firstName"] = !fields["firstName"].length ? "Erforderlich" : null;
    errors["lastName"] = !fields["lastName"].length ? "Erforderlich" : null;
    errors["email"] = !fields["email"].length ? "Erforderlich" : null;
    errors["phoneNumber"] = !fields["phoneNumber"].length
      ? "Erforderlich"
      : null;
    errors["dataCheckbox"] = !fields["dataCheckbox"] ? "Erforderlich" : null;
    errors["termsCheckbox"] = !fields["termsCheckbox"] ? "Erforderlich" : null;
    errors["street"] = !fields["street"].length ? "Erforderlich" : null;
    errors["houseNumber"] = !fields["houseNumber"].length
      ? "Erforderlich"
      : null;
    errors["city"] = !fields["city"].length ? "Erforderlich" : null;
    errors["zipcode"] = !fields["zipcode"].length ? "Erforderlich" : null;
    errors["country"] = !fields["country"] ? "Erforderlich" : null;

    for (let name of fieldNames) {
      if (errors[name]) foundErrors = true;
    }

    return { ...errors, foundErrors };
  };

  const handleNextPage = () => {
    const validatedFields = validateFields();
    if (validatedFields.foundErrors) {
      return setValidationErrors(validatedFields);
    }

    const storage = getOnboardingStorage();
    const registrationData = getPreparedRegistrationData({
      onboarding_storage: storage,
      coachInfo: coach,
      userInfo: fieldData,
    });
    const obj = {
      ...registrationData,
      birthday: moment(registrationData.birthday, "DD.MM.YYYY").format(
        "YYYY-MM-DD"
      ),
    };
       // Prepare data for APIs
    const updateUserData = {
      userID: registrationData?.userID,
      street: fieldData.street,
      city: fieldData.city,
      zipcode: fieldData.zipcode,
      country: fieldData.country.label || "Deutschland",
      housenumber: fieldData.houseNumber,
    };
   
    setLoading(true);

    dispatch(
      AuthActions.registration1Request({
        formValues: obj,
        callback: (response) => {
          setLoading(false);

          if (!response.success) {
            return setRegistrationError(
              response.message || "An error has accured, please try again."
            );
          }
          updateUserInfo(
            { ...updateUserData, userID: response.$nutritionconcept.userID },
            response.access_token
          )
            .then(() => {
              console.log("User information updated successfully");
            })
            .catch((error) => {
              console.error("Failed to update user information:", error);
            });
          setOnboardingStorage(REGISTER_STEP, { ...response });
          localStorage.setItem("userEmail", fieldData.email);
          history.push(getNextOnboardingPage(currentPath),{
            ...updateUserData
          });
        },
      })
    );
  };

  if (loading) return <OnboardingLoader />;

  return (
    <div>
      <div className="step-header">
        <div className="header-content">
          <Link to={getPreviousOnboardingPage(currentPath)}>
            <img src={backIcon} alt="back icon" />
          </Link>
          <div>
            <div className="headline">Anamnese</div>
            <div className="sub-headline">
              Wir erstellen direkt dein Ernährungsplan
            </div>
          </div>
        </div>
        <div className="actions">
          <span onClick={handleNextPage} className="main-button">
            Weiter
          </span>
        </div>
      </div>
      <div className="step-content">
        <Styles.MainContainer>
          <div className="section-titles-wrapper">
            <div className="primary-title">
              Bitte gib deine persönlichen Daten ein
            </div>
            <div className="accent-subtitle mb-4">
              Deine Daten benötigen wir zum ersten des Ernährungsplanes.
            </div>
            {registrationError ? (
              <div className="error-message">{registrationError}</div>
            ) : (
              ""
            )}
          </div>

          <Styles.TermsContainer>
            <div className="grid">
              <div className="input-container">
                <div className="label">Vorname</div>
                <Input
                  name="firstName"
                  value={fieldData.firstName}
                  onChange={handleInputChange}
                  placeholder="Vorname"
                  status={validationErrors.firstName ? "error" : ""}
                />
                <div className="error-message">
                  {validationErrors.firstName}
                </div>
              </div>
              <div className="input-container">
                <div className="label">Nachname</div>
                <Input
                  name="lastName"
                  value={fieldData.lastName}
                  onChange={handleInputChange}
                  placeholder="Nachname"
                  status={validationErrors.lastName ? "error" : ""}
                />
                <div className="error-message">{validationErrors.lastName}</div>
              </div>
              <div className="input-container">
                <div className="label">Mail</div>
                <Input
                  name="email"
                  value={fieldData.email}
                  onChange={handleInputChange}
                  placeholder="E-Mail"
                  status={validationErrors.email ? "error" : ""}
                />
                <div className="error-message">{validationErrors.email}</div>
              </div>
              <div className="input-container">
                <div className="label">Handynummer</div>
                <Input
                  name="phoneNumber"
                  addonBefore={
                    <Select
                      showSearch
                      options={countryCodes}
                      onChange={(value) =>
                        handleInputChange({
                          target: { name: "selectedCountryCode", value },
                        })
                      }
                      defaultValue={fieldData.selectedCountryCode}
                      filterOption={(input, option) =>
                        option.value.includes(input) ||
                        option.name.toLowerCase().includes(input)
                      }
                    />
                  }
                  placeholder="Handynummer"
                  value={fieldData.phoneNumber}
                  onChange={handleInputChange}
                  status={validationErrors.phoneNumber ? "error" : ""}
                />
                <div className="error-message">
                  {validationErrors.phoneNumber}
                </div>
              </div>
            </div>
            <div className="accent-subtitle py-4">Deine Rechnungsanschrift</div>
            <div className="grid">
              <div className="input-container">
                <div className="label">Straße</div>
                <Input
                  name="street"
                  value={fieldData.street}
                  onChange={handleInputChange}
                  placeholder="Straße"
                  status={validationErrors.street ? "error" : ""}
                />
                <div className="error-message">{validationErrors.street}</div>
              </div>
              <div className="input-container">
                <div className="label">Hausnummer</div>
                <Input
                  name="houseNumber"
                  value={fieldData.houseNumber}
                  onChange={handleInputChange}
                  placeholder="Hsnr"
                  status={validationErrors.houseNumber ? "error" : ""}
                />
                <div className="error-message">
                  {validationErrors.houseNumber}
                </div>
              </div>
              <div className="input-container">
                <div className="label">Postleitzahl</div>
                <Input
                  name="zipcode"
                  value={fieldData.zipcode}
                  onChange={handleInputChange}
                  placeholder="Plz"
                  status={validationErrors.zipcode ? "error" : ""}
                />
                <div className="error-message">{validationErrors.zipcode}</div>
              </div>
              <div className="input-container">
                <div className="label">Ort</div>
                <Input
                  name="city"
                  value={fieldData.city}
                  onChange={handleInputChange}
                  placeholder="Ort"
                  status={validationErrors.city ? "error" : ""}
                />
                <div className="error-message">{validationErrors.city}</div>
              </div>
            </div>

            <div className="label-land">Land</div>
            <Styles.CountrySelectWrapper hasError={validationErrors.country}>
              <Select
                style={{ width: "100%", height: "45px" }}
                options={countryOptions}
                value={fieldData.country}
                onChange={handleCountryChange}
                className="country-select"
                classNamePrefix="country-select"
                placeholder="Land auswählen"
                suffixIcon={<FaChevronDown />}
              />
            </Styles.CountrySelectWrapper>

            <div className="footer">
              <div className="check-item">
                <Checkbox
                  onChange={() =>
                    handleInputChange({
                      target: {
                        name: "dataCheckbox",
                        value: !fieldData.dataCheckbox,
                      },
                    })
                  }
                  checked={fieldData.dataCheckbox}
                />
                <span>
                  Ich erkläre mich damit einverstanden, dass meine Daten für die
                  Erstellung des individuellen Ernährungskonzeptes verwendet,
                  verarbeitet und gespeichert werden dürfen.
                </span>
              </div>
              <div className="error-message">
                {validationErrors.dataCheckbox}
              </div>

              <div className="check-item negative-margin">
                <Checkbox
                  onChange={() =>
                    handleInputChange({
                      target: {
                        name: "termsCheckbox",
                        value: !fieldData.termsCheckbox,
                      },
                    })
                  }
                  checked={fieldData.termsCheckbox}
                />

                <span>
                  Ich habe die{" "}
                  <a
                    target="_blank"
                    href="https://foodiary.app/terms/agb-coaching/"
                  >
                    AGB
                  </a>{" "}
                  und die{" "}
                  <a
                    target="_blank"
                    href="https://foodiary.app/terms/datenschutz/"
                  >
                    Datenschutzbestimmungen
                  </a>{" "}
                  gelesen und verstanden.
                </span>
              </div>
              <div className="error-message">
                {validationErrors.termsCheckbox}
              </div>
            </div>
          </Styles.TermsContainer>
        </Styles.MainContainer>
      </div>
    </div>
  );
}

export default TermsInfo;
